import React, { Fragment } from "react";

const ProtectedLayout = ({ children }) => {
  return <Fragment>{children}</Fragment>;
};

export default ProtectedLayout;
